import { render, staticRenderFns } from "./CA.vue?vue&type=template&id=ed2d0c6a&scoped=true"
import script from "./CA.vue?vue&type=script&lang=js"
export * from "./CA.vue?vue&type=script&lang=js"
import style0 from "./CA.vue?vue&type=style&index=0&id=ed2d0c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2d0c6a",
  null
  
)

export default component.exports